import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import './Modal.scss';

export const Modal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmText = 'Confirm',
  closeText = 'Cancel',
  showConfirmButton = true,
  showCloseButton = true,
  showFooter = true,
  width = '500px',
  height = 'auto',
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target) && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className='modal-overlay'>
      <div className='modal-content' ref={modalRef} style={{ width, height }}>
        {title && <div className='modal-header'>{title}</div>}

        <div className='modal-body'>{children}</div>

        {showFooter && (
          <div className='modal-footer'>
            {showCloseButton && (
              <button
                className='gigacore-button modal-button cancel-button'
                onClick={onClose}
              >
                {closeText}
              </button>
            )}

            {showConfirmButton && (
              <button
                className='gigacore-button modal-button confirm-button'
                onClick={onConfirm}
              >
                {confirmText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  confirmText: PropTypes.string,
  closeText: PropTypes.string,
  showConfirmButton: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  showFooter: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
};
